import { defaultTheme } from '../../../theming/data/defaultTheme'
import fonts from '../../../tokens/fonts'
import styled from 'styled-components'
import { composeTheme } from '../../../utils/compose-theme'

export const Container = styled.section`
  display: ${(props) => (props.theme.collapsed ? 'block' : 'inline-block')};
  position: relative;
  margin-bottom: ${(props) => (props.theme.collapsed ? '0rem' : '1.6rem')};
  width: 100%;
`

export const Title = styled.div.attrs((props) => composeTheme(props))`
  display: ${(props) => (props.theme.collapsed ? 'none' : 'inline-block')};
  text-align: left;
  font-size: ${(props) => props.theme.sideMenuAlt.sectionFontSize};
  font-family: ${fonts.inter};
  font-weight: ${(props) => props.theme.sideMenuAlt.sectionWeight};
  line-height: ${(props) => props.theme.sideMenuAlt.sectionLineHeight};
  color: ${(props) => props.theme.sideMenuAlt.sectionColor};
  text-transform: uppercase;
`

Title.defaultProps = defaultTheme
Container.defaultProps = defaultTheme
